/* ==========================================================================
   KaiHome custom scripts
   1) Topbar tek satır auto-fit
   2) Ürün kartı görsel slider + noktalar
   3) Sepete ekle -> drawer AÇMADAN ekle + "Eklendi" + sayaç artır
   4) Sağ-alt yüzen sepet ikonu: header görünmeyince çıkar
   5) Sticky ATC açıkken yüzen butonları yukarı kaydır
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- yardımcılar ---------- */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function cartAddUrl() {
    if (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_add_url) return FoxTheme.routes.cart_add_url;
    return root + 'cart/add.js';
  }
  function cartUrl() {
    if (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) return FoxTheme.routes.cart_url;
    return root + 'cart.js';
  }
  function publishCart(cart) {
    // Tema pubsub'ı varsa <cart-count> ve cart-drawer otomatik güncellenir
    try {
      if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
      }
    } catch (e) {}
    // Yedek: sayaçları elle güncelle
    updateCounts(cart.item_count);
  }
  function updateCounts(count) {
    var text = count > 99 ? '99+' : String(count);
    document.querySelectorAll('cart-count, .cart-count, .kai-fab__count').forEach(function (el) {
      el.textContent = text;
      if (count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    document.documentElement.classList[count > 0 ? 'add' : 'remove']('cart-has-items');
  }

  /* ==========================================================================
     1) TOPBAR — tek satır, taşarsa fontu küçült
     ========================================================================== */
  function fitTopbar() {
    document.querySelectorAll('.topbar__text').forEach(function (box) {
      box.setAttribute('data-kai-fit', '');
      box.style.removeProperty('--kai-topbar-fs');
      var base = parseFloat(getComputedStyle(box).fontSize) || 14;
      var size = base;
      var guard = 0;
      // taşma varsa 9px'e kadar küçült
      while (box.scrollWidth > box.clientWidth + 1 && size > 9 && guard < 40) {
        size -= 0.5;
        box.style.setProperty('--kai-topbar-fs', size + 'px');
        guard++;
      }
    });
  }

  /* ==========================================================================
     2) KART SLIDER + NOKTALAR
     ========================================================================== */
  function initSliders(scope) {
    (scope || document).querySelectorAll('[data-kai-slider]').forEach(function (slider) {
      if (slider.dataset.kaiSliderInit) return;
      slider.dataset.kaiSliderInit = '1';
      var track = slider.querySelector('.kai-slider__track');
      var dots = Array.prototype.slice.call(slider.querySelectorAll('.kai-dot'));
      if (!track || dots.length < 2) return;

      function setActive(i) {
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      }
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i < 0) i = 0;
          if (i > dots.length - 1) i = dots.length - 1;
          setActive(i);
        });
      }, { passive: true });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
          setActive(i);
        });
      });
    });
  }

  /* ==========================================================================
     3) SEPETE EKLE — drawer açmadan ekle
     ========================================================================== */
  function handleQuickAdd(form) {
    var btn = form.querySelector('.kai-atc');
    if (btn && (btn.classList.contains('is-loading') || btn.classList.contains('is-disabled'))) return;
    var textEl = btn ? btn.querySelector('.kai-atc__text') : null;
    var original = textEl ? textEl.textContent : '';
    if (btn) btn.classList.add('is-loading');

    // Sepet drawer'ının ANINDA güncellenmesi için render edilecek section'ları topla
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    var formData = new FormData(form);
    formData.append('sections', sectionsToBundle);
    formData.append('sections_url', window.location.pathname);

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          // hata
          if (btn) btn.classList.remove('is-loading');
          if (textEl) {
            textEl.textContent = (res.data && res.data.description) ? 'Stokta yok' : 'Hata';
            setTimeout(function () { if (textEl) textEl.textContent = original; }, 1800);
          }
          return null;
        }
        var addedSections = res.data.sections;
        return fetch(cartUrl(), { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { cart.sections = addedSections; return cart; });
      })
      .then(function (cart) {
        if (!cart) return;
        publishCart(cart);
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          if (textEl) textEl.textContent = 'Eklendi ✓';
          setTimeout(function () {
            btn.classList.remove('is-added');
            if (textEl) textEl.textContent = original;
          }, 1700);
        }
      })
      .catch(function () {
        if (btn) btn.classList.remove('is-loading');
        if (textEl) {
          textEl.textContent = 'Hata';
          setTimeout(function () { if (textEl) textEl.textContent = original; }, 1800);
        }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.classList && form.classList.contains('kai-atc__form')) {
      e.preventDefault();
      e.stopPropagation();
      handleQuickAdd(form);
    }
  }, true);

  /* ==========================================================================
     4) YÜZEN SEPET İKONU — header görünmeyince göster
     ========================================================================== */
  function initFloatingCart() {
    var fab = document.querySelector('.kai-fab--cart');
    if (!fab) return;
    var header =
      document.querySelector('.shopify-section-group-header-group') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('.section-header') ||
      document.querySelector('.header') ||
      document.querySelector('header');

    if ('IntersectionObserver' in window && header) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          fab.classList.toggle('kai-show', !entry.isIntersecting);
        });
      }, { rootMargin: '0px', threshold: 0 });
      io.observe(header);
    } else {
      // fallback: scroll eşiği
      var onScroll = function () {
        fab.classList.toggle('kai-show', window.scrollY > 260);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* ==========================================================================
     5) STICKY ATC açıkken body class'ı (yüzen butonlar yukarı)
     ========================================================================== */
  function initStickyWatch() {
    var bar = document.querySelector('.sticky-atc-bar');
    if (!bar) return;
    var apply = function () {
      document.body.classList.toggle('kai-sticky-atc-on', bar.classList.contains('sticky-atc-bar--show'));
    };
    var mo = new MutationObserver(apply);
    mo.observe(bar, { attributes: true, attributeFilter: ['class'] });
    apply();
  }

  /* ==========================================================================
     6) Sepet drawer'ı / mobil menü açıkken yüzen butonları gizle
     ========================================================================== */
  function initDrawerWatch() {
    var drawers = ['#CartDrawer', '#MenuDrawer'].map(function (s) {
      return document.querySelector(s);
    }).filter(Boolean);
    if (!drawers.length) return;
    var apply = function () {
      var anyOpen = drawers.some(function (d) { return d.hasAttribute('open'); });
      document.body.classList.toggle('kai-drawer-open', anyOpen);
    };
    drawers.forEach(function (d) {
      new MutationObserver(apply).observe(d, { attributes: true, attributeFilter: ['open'] });
    });
    apply();
  }

  /* ---------- başlat ---------- */
  function init() {
    fitTopbar();
    initSliders(document);
    initFloatingCart();
    initStickyWatch();
    initDrawerWatch();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', fitTopbar);
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(fitTopbar, 150);
  });

  // Shopify tema editörü uyumu
  document.addEventListener('shopify:section:load', function () {
    fitTopbar();
    initSliders(document);
    initFloatingCart();
    initStickyWatch();
    initDrawerWatch();
  });
})();
